import { Center, Text } from "@chakra-ui/react";
import { useCustomerContext } from "contexts/CustomerProvider";
import { mobileStyleBreakpoint } from "util/styleHelpers";

const textStyle = mobileStyleBreakpoint("h4", "h3");

const SingleCustomerSelectionCheck = ({
  actionDescription,
  children,
}: {
  actionDescription: string;
  children?: JSX.Element;
}) => {
  const { selectedCustomers } = useCustomerContext();

  return (
    <>
      {selectedCustomers.length === 1 ? (
        children
      ) : (
        <Center mt={8} pt={12}>
          <Text textStyle={textStyle} textAlign="center">
            Select a single customer code to {actionDescription}
          </Text>
        </Center>
      )}
    </>
  );
};

export default SingleCustomerSelectionCheck;
